<template>
    <div class="spark-screen container">
        <div class="row">
            <div class="col-md-3 spark-settings-tabs">
                <aside>
                    <h3 class="nav-heading ">
                        Project Management Behaviors
                    </h3>
                    <ul class="nav flex-column mb-4 ">
                        <li class="nav-item">
                            <a class="nav-link project-management-controls"
                               href="#clientNextFollowUp"
                               role="tab"
                               data-toggle="tab"
                               @click="()=> selectedProjectStage = 'follow_up'">
                                <div class="red-indicator mr-2 mt-1 text-white text-center" v-if="followupProjects.late > 0">
                                    {{ followupProjects.late }}
                                </div>
                                <div :class="{underline: selectedProjectStage === 'follow_up'}">
                                    Follow Up
                                </div>
                            </a>
                        </li>
                        <li class="nav-item" v-for="(projectStage, idx) in projectStages" :key="idx">
                            <a
                                class="nav-link project-management-controls"
                                v-bind:href="'#projectStage' + projectStage.id"
                                role="tab"
                                data-toggle="tab"
                                @click="()=> selectedProjectStage = projectStage.id"
                            >
                                <div
                                    class="red-indicator mr-2 mt-1 text-white text-center"
                                    v-if="projectStage.total_projects_delayed > 0"
                                >
                                    {{ projectStage.total_projects_delayed }}
                                </div>
                                <div :class="{underline: selectedProjectStage == projectStage.id}">
                                    {{ projectStage.short_description }}
                                </div>
                            </a>
                        </li>
                    </ul>
                </aside>
            </div>

            <div class="col-md-9">
                <div class="tab-content">
                    <div
                        role="tabcard"
                        class="tab-pane"
                        id="clientNextFollowUp">
                        <project-management-dashboard-followup
                            :follow-projects="followupProjects"
                        />
                    </div>
                    <div
                        role="tabcard"
                        class="tab-pane"
                        v-for="projectStage in projectStages"
                        v-bind:id="'projectStage' + projectStage.id">
                        <div class="rounded w-full px-2">
                            <table class="text-left w-full border-collapse">
                                <thead>
                                <tr>
                                    <th colspan="8" class="text-center bg-teal text-white">
                                        {{ projectStage.short_description }}
                                    </th>
                                </tr>
                                <tr>
                                    <th class="bg-grey-lightest border-b border-grey-light"></th>
                                    <th class="pl-2 py-3 bg-grey-lightest border-b border-grey-light">
                                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                                :class="sortBy === 'behavior' ? 'text-teal' : ''"
                                                @click="order('behavior')">
                                            PM Behavior
                                            <i class="fa fa-xs fa-chevron-down ml-2"
                                               v-if="sortBy === 'behavior' && sortDirection === 'desc'"></i>
                                            <i class="fa fa-xs fa-chevron-up ml-2"
                                               v-if="sortBy === 'behavior' && sortDirection === 'asc'"></i>
                                        </button>
                                    </th>
                                    <th class="py-3 bg-grey-lightest border-b border-grey-light">
                                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                                :class="sortBy === 'id' ? 'text-teal' : ''"
                                                @click="order('id')">
                                            ProjectID
                                            <i class="fa fa-xs fa-chevron-down ml-2"
                                               v-if="sortBy === 'id' && sortDirection === 'desc'"></i>
                                            <i class="fa fa-xs fa-chevron-up ml-2"
                                               v-if="sortBy === 'id' && sortDirection === 'asc'"></i>
                                        </button>
                                    </th>
                                    <th class="py-3 bg-grey-lightest border-b border-grey-light">
                                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                                :class="sortBy === 'name' ? 'text-teal' : ''"
                                                @click="order('name')">
                                            Project Name
                                            <i class="fa fa-xs fa-chevron-down ml-2"
                                               v-if="sortBy === 'name' && sortDirection === 'desc'"></i>
                                            <i class="fa fa-xs fa-chevron-up ml-2"
                                               v-if="sortBy === 'name' && sortDirection === 'asc'"></i>
                                        </button>
                                    </th>
                                    <th class="py-3 bg-grey-lightest border-b border-grey-light hidden sm:table-cell">
                                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                                :class="sortBy === 'due_date' ? 'text-teal' : ''"
                                                @click="order('due_date')">
                                            Due Date
                                            <i class="fa fa-xs fa-chevron-down ml-2"
                                               v-if="sortBy === 'due_date' && sortDirection === 'desc'"></i>
                                            <i class="fa fa-xs fa-chevron-up ml-2"
                                               v-if="sortBy === 'due_date' && sortDirection === 'asc'"></i>
                                        </button>
                                    </th>
                                    <th class="py-3 bg-grey-lightest border-b border-grey-light hidden lg:table-cell">
                                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                                :class="sortBy === 'user' ? 'text-teal' : ''"
                                                @click="order('user')">
                                            Assigned
                                            <i class="fa fa-xs fa-chevron-down ml-2"
                                               v-if="sortBy === 'user' && sortDirection === 'desc'"></i>
                                            <i class="fa fa-xs fa-chevron-up ml-2"
                                               v-if="sortBy === 'user' && sortDirection === 'asc'"></i>
                                        </button>
                                    </th>
                                    <th class="py-3 bg-grey-lightest border-b border-grey-light hidden md:table-cell">
                                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                                :class="sortBy === 'stage' ? 'text-teal' : ''"
                                                @click="order('stage')">
                                            Project Stage
                                            <i class="fa fa-xs fa-chevron-down ml-2"
                                               v-if="sortBy === 'stage' && sortDirection === 'desc'"></i>
                                            <i class="fa fa-xs fa-chevron-up ml-2"
                                               v-if="sortBy === 'stage' && sortDirection === 'asc'"></i>
                                        </button>
                                    </th>
                                    <th class="py-3 bg-grey-lightest border-b border-grey-light hidden lg:table-cell">
                                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                                :class="sortBy === 'age' ? 'text-teal' : ''"
                                                @click="order('age')">
                                            Age
                                            <i class="fa fa-xs fa-chevron-down ml-2"
                                               v-if="sortBy === 'age' && sortDirection === 'desc'"></i>
                                            <i class="fa fa-xs fa-chevron-up ml-2"
                                               v-if="sortBy === 'age' && sortDirection === 'asc'"></i>
                                        </button>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        class="hover:bg-grey-lighter cursor-pointer"
                                        v-for="(projectManagement, idx) in orderedProjects(projectStage.projects_management)"
                                        @click="goToProject(projectManagement)"
                                        :key="idx"
                                    >
                                        <td class="pl-2 py-2 border-b bg-green" v-if="projectManagement.delayed"></td>
                                        <td class="pl-2 py-2 border-b bg-red" v-else></td>
                                        <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs">
                                            {{ projectManagement.behavior }}
                                        </td>
                                        <td class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs">
                                            {{ projectManagement.id }}
                                        </td>
                                        <td class="py-2 border-b border-grey-light text-grey-darkest text-xs">
                                            {{ projectManagement.name }}
                                        </td>
                                        <td class="py-2 border-b border-grey-light text-grey-darkest text-xs">
                                            {{ projectManagement.due_date }}
                                        </td>
                                        <td class="py-2 border-b border-grey-light text-grey-darkest text-xs hidden sm:table-cell">
                                            {{ projectManagement.user }}
                                        </td>
                                        <td class="py-2 border-b border-grey-light text-grey-darkest text-xs hidden lg:table-cell">
                                            {{ projectManagement.stage }}
                                        </td>
                                        <td class="py-2 border-b border-grey-light text-grey-darkest text-xs hidden md:table-cell">
                                            {{ projectManagement.age }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProjectManagementDashboardFollowup from "./project-management-dashboard-followup";
    export default {
        components: {ProjectManagementDashboardFollowup},
        props: ['projectStages', 'followupProjects'],
        data() {
            return {
                sortBy: null,
                sortDirection: null,
                selectedProjectStage:null
            }
        },
        mounted(){
            document.getElementsByClassName('project-management-controls')[0].click();
        },
        created(){
            this.sortBy = 'due_date';
            this.sortDirection = 'asc';
        },
        methods: {
            orderedProjects(projects) {
                return _.orderBy(projects, this.sortBy, this.sortDirection)
            },
            order(field) {
                if (this.sortBy == field){
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                }else{
                    this.sortBy = field;
                    this.sortDirection = 'asc';
                }
            },
            goToProject(projectManagement) {
                window.location = route('project-management.project.edit', {projectManagement: projectManagement.id, dashboard: 1});
            }
        }
    }
</script>
